enum WorkspaceProjectCertificationDocumentStatus {
  Draft = 'Draft',
  Published = 'Published',
}

export default WorkspaceProjectCertificationDocumentStatus
